import { combineEpics } from 'redux-observable';

import { findEncryptPseudonymsEpic } from './FindEncryptPseudonyms/FindEncryptPseudonymsEpic';
import { findSingleEncryptPseudonymsEpic } from './FindSingleEncryptPseudonyms/FindSingleEncryptPseudonymsEpic';

export default combineEpics(
  findEncryptPseudonymsEpic,
  findSingleEncryptPseudonymsEpic,
);
